export default __webpack_public_path__ + "static/media/fidelity.02990ed7.png";